import { Banner, Genie } from "@kaltura/mediaspace-features-genie";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

export { Banner, Genie };
export const renderGeniePage = getDsLayoutComponentRenderer(Genie);
